import Layout from '@/views/layout'
export default {
  path: '/appManagement',
  menuName: 'APP 管理',
  component: Layout,
  name: 'appManagement',
  meta: { title: 'E-CALL', icon: 'APP-management', iconType: 'svg' },
  children: [
    {
      path: 'notice',
      name: 'notice',
      menuName: '通知提醒',
      component: () => import('@/views/appManagement/notice'),
      meta: { title: 'notice', icon: 'notice', iconType: 'svg' }
    },
    {
      path: 'banner',
      name: 'Banner',
      component: () => import('@/views/userCenter/banner'),
      menuName: '横幅',
      meta: { title: 'shop', icon: 'banner', iconType: 'svg' }
    },
    {
      path: 'shop',
      name: 'shop',
      component: () => import('@/views/userCenter/shop'),
      menuName: '商铺维护',
      meta: { title: 'shop', icon: 'shop', iconType: 'svg' }
    },
  ]
}